import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream-100 px-6 pb-14 sm:pb-16" aria-labelledby="faq-titulo" data-id="element-49" data-mp="1bmvdgxk5o8r8">
      <div className="mx-auto max-w-3xl" data-id="element-50" data-mp="1glgcwurl2oem">
        <h2 id="faq-titulo" className="text-center font-display text-3xl font-bold leading-tight text-forest-800 sm:text-4xl" data-id="element-51" data-mp="248y1khfjx6dd">
          Preguntas Frecuentes
        </h2>

        <ul className="mt-7 grid gap-2.5" data-id="element-52" data-mp="1uibp2w34svyw">
          {faqs.map(({
          question,
          answer
        }, index) => {
          const isOpen = openIndex === index;
          return <li key={question} className="overflow-hidden rounded-xl border border-cream-300/70 bg-cream-50" data-id="element-53" data-mp="2n8bxv60r6t71" data-mpi={index}>
                <h3 data-id="element-54" data-mp="2s03d4keglchv">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-5 py-4 text-left font-semibold text-forest-800 transition-colors duration-150 ease-out hover:text-ember-500" data-id="element-55" data-mp="2s0ll2eahhf5m">
                    {question}
                    {isOpen ? <MinusIcon className="h-4 w-4 shrink-0 text-ember-500" aria-hidden="true" data-id="element-56" data-mp="1oi86gprc4rj7" /> : <PlusIcon className="h-4 w-4 shrink-0 text-forest-400" aria-hidden="true" data-id="element-57" data-mp="1jjx04p090z5q" />}
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-58" data-mp="1skmox8r3dp9y">
                  {isOpen ? <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-59" data-mp="35ew5v8i1r00">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-forest-700/75" data-id="element-60" data-mp="23aagfq9pmn4v">{answer}</p>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}